import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBaseUrl } from '../utils/utils';
import { restoreModernSession } from '../utils/sessionAuth';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();
  const baseUrl = useBaseUrl();

  useEffect(() => {
    let mounted = true;

    restoreModernSession(baseUrl)
      .then((session) => {
        if (!mounted) return;
        setIsAuthenticated(session?.user?.role === 'patient');
      })
      .catch(() => {
        if (!mounted) return;
        setIsAuthenticated(false);
      });

    return () => {
      mounted = false;
    };
  }, [baseUrl]);

  if (isAuthenticated === null) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/patient/login"
        state={{ from: location, message: "You need to login first." }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute; 